import { useFlightTranslation } from "../../../../utils/customHooks/useFlightTranslation";
import { LineRolesEnum, TILE_DECORATOR_HEIGHT } from "constants/constants";
import { Flag } from "@mui/icons-material";
import styled from "styled-components/macro";
import FocusIcon from "@mui/icons-material/VerticalAlignCenter";
import {
  lightAccentSuccess10,
  lightAccentSuccess50,
  lightAccentSuccess90,
} from "constants/colors";
import { getPgKey, useVisibleGroups } from "utils/customHooks/genericHooks";
import { useSelector } from "store/useSelector";

export const LINE_ROLE_ICONS = {
  [LineRolesEnum.LEADER]: <Flag />,
  [LineRolesEnum.CONSTRAINT]: (
    <FocusIcon style={{ transform: "rotate(90deg)" }} />
  ),
};
const MARGIN_BOTTOM = 4;
/** indicator above the ProcessTile to indicate specialty processes e.g. "Leader", "Constraint" */
export function LineRoleDecorator({ lineRole }: { lineRole?: LineRolesEnum }) {
  const { translate } = useFlightTranslation();
  const lineRoleIcon = lineRole && LINE_ROLE_ICONS[lineRole];
  return lineRole && lineRole !== LineRolesEnum.STANDARD ? (
    <LineRoleDecoratorStyles>
      {lineRoleIcon}
      {translate(lineRole)}
    </LineRoleDecoratorStyles>
  ) : (
    <div
      className="lineRoleSpacer"
      style={{ height: TILE_DECORATOR_HEIGHT + MARGIN_BOTTOM }}
    />
  );
}
const LineRoleDecoratorStyles = styled.div`
  font-family: "Open Sans";
  height: ${TILE_DECORATOR_HEIGHT}px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${lightAccentSuccess10};
  border: 1px solid ${lightAccentSuccess50};
  color: ${lightAccentSuccess90};
  font-size: 14px;
  margin-bottom: ${MARGIN_BOTTOM}px;
  border-radius: 4px;
  font-weight: bold;
  .MuiSvgIcon-root {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
`;

/** leader/constraint process ids on pages with a single visibleGroup (Timeline, Tiles, Hublet) */
export function useLeaderConstraintProcessIds() {
  const visibleGroups = useVisibleGroups();
  const visibleGroup = visibleGroups.length === 1 ? visibleGroups[0] : null;
  const pgKey = getPgKey(visibleGroup?.summaryGroup || "");
  const constraintProcessIds = useSelector(state =>
    visibleGroup ? state.legacy.constraintProcessIds[pgKey.toLowerCase()] : null
  );
  const leaderProcessId = useSelector(state =>
    visibleGroup ? state.legacy.leaderProcessId[pgKey.toLowerCase()] : null
  );
  return { leaderProcessId, constraintProcessIds };
}
